import { useState, useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";
import { useAuth } from "./Auth/AuthPage.jsx";

export const Feedback = (props) => {
    const { feedback, setFeedback } = useAuth();
    const { message, color = "success" } = feedback;
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (message) {
            setOpen(true);
        }
    }, [feedback]);

    const handleClose = () => {
        setOpen(false);
        setFeedback({ message: "", color: "success" });
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            message={color === "success" ? feedback?.message : undefined}
        >
            {color !== "success" ? (
                <Alert
                    onClose={handleClose}
                    severity="warning"
                    variant="filled"
                >
                    {feedback?.message}
                </Alert>
            ) : undefined}
        </Snackbar>
    );
};
